export default import.meta.ROLLDOWN_FILE_URL_sLTHpKsMCAfgHvMqxWqT0w